// Auto-resize textarea to fit its content
function resize (el) {
  el.style.height = 'auto'
  el.style.height = el.scrollHeight + 'px'
}

export const autoresize = {
  mounted (el) {
    el.style.overflow = 'hidden'
    el.addEventListener('input', () => resize(el))
    resize(el)
  },
  updated (el) {
    resize(el)
  }
}
